<app-modal [modalConfig]="modalConfig">
    <form [formGroup]="parameterListForm" (ngSubmit)="onSubmit()">
        <div class="manage-parameter">
            <div class="input-container">
                <label>
                    Nombre
                    <span class="mandatory">*</span>
                </label>
                <input class="form-input" formControlName="name" type="text" [ngClass]="{'error':hasErrors('name')}">
            </div>
            <div class="input-container">
                <label>
                    Tipo
                    <span class="mandatory">*</span>
                </label>
                <select class="form-input" formControlName="type" [ngClass]="{'error':hasErrors('type')}">
                    <option [ngValue]="null" selected disabled hidden>Seleccione</option>
                    <option *ngFor="let option of types | keyvalue" [value]="option.key">{{option.value}}
                    </option>
                </select>
            </div>
            <div class="input-container">
                <label>
                    Es lista dinamica
                </label>
                <div class="check-container">
                    <input class="form-check-input mt-0" type="checkbox" formControlName="isSourceType">
                </div>
            </div>
            <div class="input-container" *ngIf="getControl('isSourceType')?.value">
                <label>
                    Origen
                    <span class="mandatory">*</span>
                </label>
                <app-typeahead [editable]=" false" [control]="getControl('source')" [searchOptions]="sources$" />
            </div>
            <app-multiple-input *ngIf="!getControl('isSourceType')?.value" [input]="getOptionInput()"
                [formArray]="options" />
            <button class="btn-submit" [disabled]="isLoading">{{parameterList?"Guardar":"Crear"}}</button>
        </div>
        <ngx-loading [show]="isLoading">
        </ngx-loading>
    </form>
</app-modal>